const DeliveryBanner = () => null;

export default DeliveryBanner;
